module.exports = __webpack_public_path__ + "static/media/02-Bogota.1b5f24a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/02-Bogota.png
// module id = 1035
// module chunks = 0